<template>
  <div class="home pt-4">
    <b-container>
      <b-row>
        <MainLeftBlock :dataSport="dataSport"></MainLeftBlock>
        <MainCenterBlock :dataSport="dataSport"></MainCenterBlock>
        <MainRightBlock :dataSport="dataSport"></MainRightBlock>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import MainLeftBlock from '@/components/blocks/ufc/MainLeftBlock.vue';
import MainCenterBlock from '@/components/blocks/MainCenterBlock.vue';
import MainRightBlock from '@/components/blocks/ufc/MainRightBlock.vue';

export default {
  name: "ufc_home",
  data() {
    return {
      dataSport:
        {
          textClass: "ufc-text-color",
          kindOfSport: "ufc",
          sportId: 6,
          link_api: "ufc"
        }
    }
  },
  components: {
    MainLeftBlock,
    MainCenterBlock,
    MainRightBlock
  },
  mounted() {

  },
  metaInfo () {
      return {
          title: this.$t('meta.sports.ufc.main.title'),
          titleTemplate: 'H2H Liga | %s',
          meta: [
            {name: 'description', content: this.$t('meta.sports.ufc.main.description')},
            {name: 'keywords', content: this.$t('meta.sports.ufc.main.keywords')}
          ]
      }
  }
};
</script>
<style>
.game-border-bottom.ufc_border:not(:last-child):hover {
  border-bottom: 1px solid rgba(206, 0, 0, 0.58) !important;
  transition: all 0.5s;
}
</style>
